import { render, staticRenderFns } from "./PdpSummarizedInfo.vue?vue&type=template&id=f69f1f44&scoped=true&"
import script from "./PdpSummarizedInfo.vue?vue&type=script&lang=js&"
export * from "./PdpSummarizedInfo.vue?vue&type=script&lang=js&"
import style0 from "./PdpSummarizedInfo.vue?vue&type=style&index=0&id=f69f1f44&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f69f1f44",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F02-molecules%2Fpdp-summarized-info%2FPdpSummarizedInfo.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports